<template>
  <Datepicker
    v-model="date"
    :value-type="computedValueType"
    :format="format"
    :clearable="range"
    :disabled="disabled"
    :placeholder="placeholder"
    :range="range"
    :confirm="range"
    :multiple="false"
    :lang="{
      days: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
      yearFormat: 'YYYY',
      monthFormat: 'MMMM',
    }"
    @input="onInput"
  >
    <template v-slot:icon-calendar>
      <img v-if="isHasCalendarIcon" src="../../../public/custom/images/calendar.svg" alt="Calendar image">
      <svg v-else></svg>
    </template>
  </Datepicker>
</template>

<script>
import Datepicker from "vue2-datepicker";
import "vue2-datepicker/locale/ru";
import 'vue2-datepicker/index.css';

export default {
  name: "BaseDatepicker",
  components: {
    Datepicker,
  },
  props: {
    defaultValue: [String, Array],
    isHasCalendarIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    range: {
      type: Boolean,
      default: false,
    },
    valueType: {
      type: String,
      default() {
        return 'YYYY-MM-DD';
      }
    },
    format: {
      type: String,
      default() {
        return 'YYYY-MM-DD';
      }
    }
  },
  data() {
    return {
      date: this.defaultValue || null,
    };
  },
  computed: {
    computedValueType() {
      return this.range ? 'format' : this.valueType;
    }
  },
  methods: {
    onInput(value) {
      const formattedValue = this.normalizeValue(value);

      this.date = formattedValue || null;
      this.$emit('input', formattedValue);
    },
    normalizeValue(value) {
      if (!value) {
        return undefined;
      }

      if (Array.isArray(value) && (!value[0] || value[0] === null)) {
        return undefined;
      }

      return value;
    }
  },
  watch: {
    defaultValue(value) {
      this.date = value || null;
    }
  }
};
</script>

<style lang="scss" scoped></style>
